import React from 'react';
import {TextInput} from 'src/lib/components/TextInput.component';

export const NoDataAlertInput = React.forwardRef<HTMLInputElement, {defaultValue?: string; disabled?: boolean}>(
  (props, ref) => <TextInput
    {...props}
    ref={ref}
    type="number"
    min={5}
    step={1}
    max={150119987579}
    placeholder="例：30"
    labelProps={{children: <>
      <div>未受信アラートまでの時間（分・最短5分）</div>
      <div className="text-[11px]">指定した分数以上データが届かない場合、アラート通知先にメールを送ります。未受信が続く間は、前回の通知から5分以上空けて再通知します。時間または通知先が空欄の場合、未受信アラートは送信しません。</div>
    </>}}
    containerProps={{className: 'w-1/3 basis-full', style: {minWidth: '12rem'}}}
  />,
);
